import http from "../../../http-commonv2";

const list = () => {
  return http.get(`/api/v2/management/permissionsGroup/list`);
};

const create = (data) => {
  return http.post(`/api/v2/management/permissionsGroup/create`, data);
};

const update = ({ id, data }) => {
  return http.put(`/api/v2/management/permissionsGroup/update?id=${id}`, data);
};

const deleteById = (id) => {
  return http.delete(`/api/v2/management/permissionsGroup/delete?id=${id}`);
};

const getUsersAndQueues = () => {
  return http.get(`/api/v2/management/getQueuesAndUsers`);
};

const getMyPermissions = () => {
  return http.get(`/api/v2/permissions/me`);
};

const PermissionsGroupService = {
  list,
  create,
  update,
  deleteById,
  getUsersAndQueues,
  getMyPermissions,
};

export default PermissionsGroupService;
